// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GIt6","col":"styles_col__2kj90"};